import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { useQueryLoader } from '../../data-table/Loaders';
import { filterId as siteFilterId } from '../../filters/site-filter/SiteFilter';
import { usePageStateValue } from '../../../stores/PageStateStore';
import ReportingDataTable from '../../data-table/ReportingDataTable';
import { statusFilterId, timeRangeFilterId } from '../../filters';
import { getLogger } from '../../../utilities/UseLog';

const log = getLogger('ImpacteSitesPanel');

const title = t`Impacted Sites`;

const sorters = [{ property: 'status', direction: 'desc' }];

function ImpactedSitesPanel(props) {
    log.debug('ImpactedSitesPanel');

    const [queryId] = usePageStateValue({ key: 'queryId' });

    const dataSource = {
        url: '/query/problemSites',
        params: {
            type: 'site',
            entityFields: 'name',
            metrics: ['status', 'siteTestCounts', 'siteInfrCounts', 'queryId'],
            queryId,
            trends: ['status'],
            sort: 'status',
            renderAsEntity: true,
        },
    };

    const columns = [
        {
            type: COLUMN_TYPES.DRILLINLINK,
            title: t`Site`,
            sortable: true,
            mapping: 'site.name',
            width: 250,
            link: {
                target: '/site-detail',
                mappedFilterParams: {
                    [siteFilterId]: 'site',
                },
                pageStateParams: ['SelectedTime'],
            },
        },
        {
            title: t`Impacted Tests`,
            width: 160,
            sortable: true,
            align: 'center',
            sortProperty: 'DIVIDE(siteTestCounts.affected, siteTestCounts.total)',
            mapper: (row) => `${row.siteTestCounts?.affected} / ${row.siteTestCounts?.total}`,
        },
        {
            title: t`Problem Infrastructure`,
            width: 200,
            sortable: true,
            align: 'center',
            sortProperty: 'DIVIDE(siteInfrCounts.affected, siteInfrCounts.total)',
            mapper: (row) => `${row.siteInfrCounts?.affected} / ${row.siteInfrCounts?.total}`,
        },
        {
            type: COLUMN_TYPES.STATUSTREND,
            title: t`Status Trend`,
            sortable: true,
            sortProperty: 'status',
            mapping: 'trends.status.data',
        },
    ];

    const loader = useQueryLoader(dataSource);

    return (
        <ReportingDataTable
            panelProps={props}
            loader={loader}
            columns={columns}
            sorters={sorters}
            deletedMapping="site.deleted"
        />
    );
}

ImpactedSitesPanel.propTypes = panelPropTypes;

ImpactedSitesPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    autoHeight: true,
    minContentHeight: 130,
};

export default Panel({
    filters: {
        required: [timeRangeFilterId],
        optional: [statusFilterId],
    },
})(ImpactedSitesPanel);
